import React, { useState, useEffect } from 'react';
import { MdAttachMoney } from 'react-icons/md';
import './CurrencyInput.css';

function CurrencyInput({ value, onChange, label, required = false, hasError = false }) {
  const [displayValue, setDisplayValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      formatDisplay(value);
    }
  }, [value, isFocused]);

  const formatDisplay = (val) => {
    if (!val || val === '' || val === '0') {
      setDisplayValue('0,00');
      return;
    }

    const numValue = typeof val === 'string' ? parseFloat(val) : val;
    if (!isNaN(numValue)) {
      const formatted = numValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      setDisplayValue(formatted);
    } else {
      setDisplayValue('0,00');
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
    // Quando foca, mostra o valor numérico puro
    if (value && value !== '0') {
      const numValue = parseFloat(value);
      setDisplayValue(numValue.toString().replace('.', ','));
    } else {
      setDisplayValue('');
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
    // Ao perder o foco, formata o valor
    if (displayValue === '' || displayValue === '0') {
      onChange('0');
      setDisplayValue('0,00');
    } else {
      const numericValue = displayValue.replace(/\./g, '').replace(',', '.');
      const parsed = parseFloat(numericValue);
      if (!isNaN(parsed)) {
        onChange(parsed.toFixed(2));
        formatDisplay(parsed);
      } else {
        onChange('0');
        setDisplayValue('0,00');
      }
    }
  };

  const handleChange = (e) => {
    let input = e.target.value;
    
    // Remove tudo exceto números e vírgula
    input = input.replace(/[^\d,]/g, '');
    
    // Permite apenas uma vírgula
    const parts = input.split(',');
    if (parts.length > 2) {
      input = parts[0] + ',' + parts.slice(1).join('');
    }
    
    // Limita a 2 casas decimais após a vírgula
    if (parts.length === 2 && parts[1].length > 2) {
      input = parts[0] + ',' + parts[1].substring(0, 2);
    }
    
    setDisplayValue(input);
  };

  return (
    <div className="currency-input-wrapper">
      {label && (
        <label className="currency-input-label">
          {label}
          {required && <span className="required-mark">*</span>}
        </label>
      )}
      
      <div className={`currency-input-container ${isFocused ? 'focused' : ''} ${hasError ? 'error' : ''}`}>
        <MdAttachMoney size={20} className="currency-icon" />
        <span className="currency-prefix">R$</span>
        <input
          type="text"
          inputMode="decimal"
          value={displayValue}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required={required}
          placeholder="0,00"
          className="currency-input"
        />
      </div>
    </div>
  );
}

export default CurrencyInput;
